import React from "react";
import cx from "classnames";
import styles from "./SingleNoteContent.module.css";
import parse from "html-react-parser";

const SingleNoteContent = ({ content }) => {
    return (
        <div
            className={cx(styles.pageContent)}
            // dangerouslySetInnerHTML={{
            //     __html: content,
            // }}
        >
            {parse(content)}
        </div>
    );
};

export default SingleNoteContent;
